import {Hr} from "../../../design";
import React from "react";
import Support from "../../support";
import SmallScreenView from "../index";

type Props = {
  children: Node,
  email: string,
  phone: string,
  whiteLabel: Boolean,
}

const SmallScreenFooter = (props:Props) => {
  const {children, email, phone, whiteLabel} = props;
  return (
    <SmallScreenView>
      {children}
      <Hr marginTop="0px"/>
      <div className="px-1 px-md-4 my-2">
        <div>
          <Support email={email} phone={phone} whiteLabel={whiteLabel}/>
        </div>
      </div>
    </SmallScreenView>
  )
};

export default SmallScreenFooter;
